import { render, staticRenderFns } from "./AirportPopup.vue?vue&type=template&id=c278d024&"
import script from "./AirportPopup.vue?vue&type=script&lang=js&"
export * from "./AirportPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports